import Config from "./config.json";
import DevConfig from "./config.development.json";

let config = Config;
if(process.env.NODE_ENV === "development") {
  config = { ...Config, ...DevConfig};
}

export default config;